import { removeMethodProperty } from './removeMethodProperty';

export const mapIncluded =
  (type: string) =>
  ({ id, ...attributes }: { id: string }) => ({
    id,
    type,
    attributes: removeMethodProperty(attributes),
  });
